import { render } from "./studentStatsCards.vue?vue&type=template&id=acdabb18&scoped=true"
import script from "./studentStatsCards.vue?vue&type=script&lang=js"
export * from "./studentStatsCards.vue?vue&type=script&lang=js"

import "./studentStatsCards.vue?vue&type=style&index=0&id=acdabb18&scoped=true&lang=css"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acdabb18"]])

export default __exports__